import { windowExtended } from '@map/types';
import { sanitizePhoneNumber } from '@shared/util/phoneNumber';
import axios from 'axios';
import { useCallback, useState } from 'react';
import { buildApiUrl } from './baseApi';

export type PhoneVerificationScopes = 'register' | 'password_reset' | 'number_change';

export const usePhoneNumberVerification = () => {
  const [sentRequest, setSentRequest] = useState<{ error?: string; warning?: string } | null>(null);
  const request = useCallback((phone: string, scope: PhoneVerificationScopes) => {
    const sanitizedPhone = sanitizePhoneNumber(phone);
    let request: Promise<any>;
    if (scope === 'password_reset') {
      request = axios.post(buildApiUrl('password_reset'), { username: sanitizedPhone });
    } else {
      request = axios.post(buildApiUrl('users/verify_phone'), {
        phone: sanitizedPhone,
        access_code: windowExtended.project.access_code,
        project_slug: windowExtended.project.slug,
        scope,
      });
    }
    return request.then(({ data }) => {
      setSentRequest(data);
      return data;
    });
  }, []);
  return { sentRequest, request } as const;
};
